import axios from 'axios';
import { API_BASE_URL } from '../config';
import api from './api';

const API_URL = `${API_BASE_URL}/dashboard/`;

const defaultDashboardData = {
    prognose: { count: 0, provision: 0 },
    paid: { count: 0, provision: 0 },
    completed: { count: 0, provision: 0 },
    active_loans: [],
    ready_for_billing: [], // Loans with payment_date but no consultant_billed_date
    pending_signatures: [], // Loans without signature_date
    monthly_commission: [], // Monthly commission data for the chart
    status_distribution: [] // Status distribution data for the chart
};

export const getDashboardData = async (year = new Date().getFullYear()) => {
    try {
        const [dashboardResponse, readyForBillingResponse, pendingSignaturesResponse, monthlyCommissionResponse] = await Promise.all([
            api.get(`/dashboard/?year=${year}`),
            api.get(`/loans/ready-for-billing/?year=${year}`),
            api.get(`/loans/pending-signatures/?year=${year}`),
            api.get(`/dashboard/monthly-commission/?year=${year}`)
        ]);

        return {
            ...defaultDashboardData,
            ...dashboardResponse.data,
            ready_for_billing: readyForBillingResponse.data,
            pending_signatures: pendingSignaturesResponse.data,
            monthly_commission: monthlyCommissionResponse.data
        };
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        throw error;
    }
};

export const getDashboardDataCentralConfig = async () => {
    try {
        const response = await axios.get(API_URL, {
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        throw error;
    }
};

export const updateLoanData = async (loanId, data) => {
    try {
        // Using the correct endpoint from the DRF DefaultRouter
        const response = await api.patch(`/loans/${loanId}/`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating loan data:', error);
        throw error;
    }
};